<template>
    <common-page>
        <div class="card w-100 p-1">
            <mini-table ref="faceTable"
                        :fields="fields"
                        :items="rows"
                        read-only
                        enable-pagination
                        :total-count="totalCount"
                        custom-end-of-row-label="缩略图"
                        with-custom-actions-end-of-row
                        @pageChange="whenPageChange">
                <template #endOfRow="{row}">
                    <div class="w-100 h-100 temp-cover">
                        <b-img :src="generateImageUrl(row.fileName)" fluid-grow class="img-style"></b-img>
                        <div class="overflow-hidden position-absolute right top h-100">
                            <delete-button class="btn-cover" :loading="isDelLoading(row)" loading-class="btn-loading"
                                           @confirming="setDelLoading(row.fileName)"
                                           @noConfirm="clearDelLoading"
                                           @btnClick="delImage(row.fileName)"></delete-button>
                        </div>
                    </div>
                </template>
                <template #rightHeader>
                    <b-button variant="primary" @click="getRemoteData">
                        <i class="fa-solid fa-rotate-right"></i> 刷新
                    </b-button>
                </template>
                <template #leftHeader>
                    <b-button variant="success" @click="$refs.upload.showModal()">
                        <i class="fa-solid fa-file-arrow-up"></i> 上传人脸
                    </b-button>
                    <b-button variant="light" class="ml-1" @click="$refs.recognition.showModal()">
                        <i class="fa-solid fa-video"></i> 人脸识别
                    </b-button>
                    <b-button variant="warning" class="ml-1" @click="refreshAll">
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </b-button>
                </template>
                <template #header>
                    <single-query-input class="ml-1"
                                        style="max-width: 350px;"
                                        :value.sync="queryInput"
                                        :query-loading="queryLoading"
                                        placeholder="Enter User Login Name"
                                        @doQuery="getRemoteData"></single-query-input>
                </template>
            </mini-table>
        </div>
        <template #outer>
            <re-b-modal ref="upload" header="上传人脸">
                <faces-upload @needRefresh="getRemoteData"></faces-upload>
            </re-b-modal>

            <re-b-modal ref="recognition" header="人脸识别">
                <b-button variant="info" @click="$refs.recognize.startRecognize()">open</b-button>
                <b-button class="ml-1" @click="$refs.recognize.closeVideo()">close</b-button>
                <face-recognize ref="recognize" style="height: 300px !important;"></face-recognize>
            </re-b-modal>
        </template>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import FacesUpload from "@/components/Face/FacesUpload.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import FaceRecognize from "@/components/Face/FaceRecognize.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";
import SingleQueryInput from "@/components/common/inputs/SingleQueryInput.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "FaceList",
    mixins: [emCommonUtilMixin],
    components: {SingleQueryInput, DeleteButton, FaceRecognize, ReBModal, FacesUpload, MiniTable, CommonPage},
    data() {
        return {
            fields: [
                {key: 'userName', label: '姓名'},
                {key: 'fileName', label: '文件名'},
                {key: 'uploadTime', label: '上传时间'},
            ],
            rows: [],
            delLoading: null,
            refreshLoading: false,
            totalCount: 0,
            currentPage: {
                pageNumber: 0,
                pageSize: 20,
            },
            queryInput: '',
            queryLoading: false,
        }
    },
    mounted() {
        this.getRemoteData();
    },
    methods: {
        generateImageUrl(name) {
            return process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/face/download?fileName=" + name;
        },
        getRemoteData() {
            this.$refs.faceTable.changeLoading(true);
            this.queryLoading = true;
            let form = {
                fileName: this.queryInput
            }
            this.copyObj2Obj(this.currentPage, form);
            this.$store.dispatch('api/post', {
                url: `${process.env.VUE_APP_EM_ADMIN_URL}/emAclUser/face/all`,
                data: form
            }).then(response => {
                if (response.data) {
                    let data = response.data;
                    this.rows = data.list;
                    this.totalCount = data.caption;
                }
            }).finally(() => {
                this.$refs.faceTable.changeLoading(false);
                this.queryLoading = false;
            })
        },

        delImage(name) {
            this.setDelLoading(name);
            this.$store.dispatch('api/delete', {
                url: process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/face/del?fileName=" + name
            }).then(() => {
                this.$message.success("Delete success");
                this.delFromRows(name);
            }).finally(() => this.clearDelLoading());
        },
        isDelLoading(row) {
            return this.delLoading === row.fileName;
        },
        setDelLoading(name) {
            this.delLoading = name;
        },
        clearDelLoading() {
            this.delLoading = null;
        },
        delFromRows(name) {
            for (let i = 0; i < this.rows.length; i++) {
                if (this.rows[i].fileName === name) {
                    this.rows.splice(i, 1);
                    break;
                }
            }
        },
        refreshAll() {
            this.$bvModal.msgBoxConfirm('确认强制重置人脸数据吗？将会进行全量的人脸数据重读取', {
                title: '请确认',
                headerBgVariant: 'light',
                headerClass: 'text-dark',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                okTitle: '是',
                cancelTitle: '否',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(confirm => {
                if (confirm) {
                    this.refreshLoading = true;
                    this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/face/refresh"
                    }).then(() => {
                        this.$message.success("异步刷新成功，需要花费一些时间，请稍等");
                    }).finally(() => this.refreshLoading = false);
                }
            });
        },
        whenPageChange(page) {
            this.currentPage = page;
            this.getRemoteData();
        }
    },
}
</script>

<style scoped>
.img-style {
    max-height: 100px;
    width: auto !important;
}

.temp-cover {
    position: relative;
}

.btn-cover {
    transform: translateX(100%);
    transition: transform .3s ease-in-out;
}

.btn-loading {
    transform: translateX(0) !important;
}

.temp-cover:hover .btn-cover {
    transform: translateX(0) !important;
}
</style>
